import { DocumentDetails, DocumentType } from '@/src/types/itinerary'

export const generateYears = (startOffset: number, range: number, direction: 'past' | 'future') => {
    const currentYear = new Date().getFullYear()
    return Array.from({ length: range + 1 }, (_, i) => (direction === 'past' ? currentYear - i : currentYear + i))
}

const getCommonFields = (documentType: DocumentType) => {
    const isReadOnly = documentType === 'NATIONALID'
    return {
        nationality: {
            label: 'nationality',
            placeholder: 'select',
            readOnly: isReadOnly
        },
        countryIssued: {
            label: 'issuedCountry',
            placeholder: 'select',
            readOnly: isReadOnly
        }
    }
}

export const dateFields = {
    days: Array.from({ length: 31 }, (_, i) => i + 1),
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
}

export const travelerDocumentToInputsSegregate = (documentType: DocumentType): Record<keyof DocumentDetails, any> => {
    const expiryYears = generateYears(0, 35, 'future')

    switch (documentType) {
        case 'PASSPORT':
            return {
                docType: documentType,
                docNumber: {
                    label: 'passportNumber',
                    placeholder: 'passportNumber'
                },
                ...getCommonFields(documentType),
                // issueDate: {
                //     label: 'issueDate',
                //     ...dateFields,
                //     years: issueYears
                // },
                expiryDate: {
                    label: 'expiryDate',
                    ...dateFields,
                    years: expiryYears
                },
                issueDate: undefined,
                id: null
            }

        case 'NATIONALID':
            return {
                docType: documentType,
                docNumber: {
                    label: 'nationalId',
                    placeholder: 'nationalId'
                },
                ...getCommonFields(documentType),

                expiryDate: {
                    label: 'expiryDate',
                    ...dateFields,
                    years: expiryYears
                },
                issueDate: undefined,
                id: null
            }

        case 'IQAMA':
            return {
                docType: documentType,
                docNumber: {
                    label: 'iqamaId',
                    placeholder: 'iqamaId'
                },
                nationality: getCommonFields(documentType).nationality,
                expiryDate: {
                    label: 'expiryDate',
                    ...dateFields,
                    years: expiryYears
                },
                issueDate: undefined,
                countryIssued: undefined,
                id: null
            }

        default:
            return {
                docType: documentType,
                docNumber: undefined,
                nationality: undefined,
                countryIssued: undefined,
                expiryDate: undefined,
                issueDate: undefined,
                id: null
            }
    }
}
